(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["editorial-review-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (!root || root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';
      const track = root.querySelector('[data-reviews-track]');
      const viewport = root.querySelector('.neuer-reviews__viewport');
      if (!track || !viewport) return;
      const cards = [...track.querySelectorAll('[data-review-card]')];
      if (!cards.length) return;
      const mobile = window.matchMedia('(max-width: 749px)');
      const tablet = window.matchMedia('(max-width: 1023px)');
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let visible = 1;
      let position = 0;
      let timer;
      let inView = true;
      let moving = false;
      let touchStart = null;
      const stepSize = () => {
        const card = track.firstElementChild;
        return card ? card.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).gap) || 0) : 0;
      };
      const place = (animate) => {
        track.style.transition = animate && !motion.matches ? 'transform 700ms cubic-bezier(.22, 1, .36, 1)' : 'none';
        track.style.transform = 'translate3d(' + (-position * stepSize()) + 'px, 0, 0)';
      };
      const clone = (card) => {
        const copy = card.cloneNode(true);
        copy.removeAttribute('data-review-card');
        copy.removeAttribute('data-shopify-editor-block');
        copy.removeAttribute('id');
        copy.setAttribute('aria-hidden', 'true');
        copy.setAttribute('inert', '');
        return copy;
      };
      const build = () => {
        track.querySelectorAll('[aria-hidden="true"]').forEach((copy) => copy.remove());
        visible = Math.min(cards.length, mobile.matches ? 1 : tablet.matches ? 2 : Number(root.dataset.desktopCards) || 4);
        root.style.setProperty('--nr-visible', visible);
        for (let i = visible - 1; i >= 0; i--) track.insertBefore(clone(cards[(cards.length - visible + i) % cards.length]), track.firstChild);
        for (let i = 0; i < visible; i++) track.appendChild(clone(cards[i % cards.length]));
        position = visible;
        moving = false;
        place(false);
      };
      const stop = () => { window.clearInterval(timer); root.classList.remove('is-playing'); };
      const start = () => {
        stop();
        if (root.dataset.autoplay === 'true' && cards.length > 1 && !motion.matches && inView && !document.hidden && !root.matches(':hover') && !root.contains(document.activeElement)) {
          root.classList.add('is-playing');
          timer = window.setInterval(() => move(1), Math.max(2000, Number(root.dataset.interval) || 5000));
        }
      };
      const settle = () => {
        if (position >= visible + cards.length) position -= cards.length;
        if (position < visible) position += cards.length;
        place(false);
        moving = false;
      };
      const move = (direction) => {
        if (moving || cards.length < 2) return;
        if (root.classList.contains('is-playing')) { root.classList.remove('is-playing'); void root.offsetWidth; root.classList.add('is-playing'); }
        moving = true;
        position += direction;
        place(true);
        if (motion.matches) settle();
      };
      track.addEventListener('transitionend', (event) => { if (event.target === track && event.propertyName === 'transform') settle(); });
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', () => window.setTimeout(start, 0));
      document.addEventListener('visibilitychange', start);
      mobile.addEventListener('change', () => { build(); start(); });
      tablet.addEventListener('change', () => { build(); start(); });
      window.addEventListener('resize', () => place(false));
      motion.addEventListener('change', start);
      viewport.addEventListener('touchstart', (event) => { touchStart = event.touches[0]?.clientX ?? null; stop(); }, { passive: true });
      viewport.addEventListener('touchend', (event) => {
        if (touchStart === null) return;
        const distance = (event.changedTouches[0]?.clientX ?? touchStart) - touchStart;
        if (Math.abs(distance) > 45) move(distance < 0 ? 1 : -1);
        touchStart = null;
        start();
      }, { passive: true });
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          inView = entries[0]?.isIntersecting ?? true;
          inView ? start() : stop();
        }, { threshold: .1 });
        observer.observe(root);
      }
      build();
      start();
    };
    document.querySelectorAll('[data-neuer-reviews]').forEach(init);
    document.addEventListener('shopify:section:load', (event) => {
      if (event.target.matches?.('[data-neuer-reviews]')) init(event.target);
      event.target.querySelectorAll?.('[data-neuer-reviews]').forEach(init);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["neuer-editable-brand-banner"] && !Shopify.designMode) return;
  try {
    
const neuerEditorialFadeInstances = new WeakMap();
const initNeuerEditorialFade = root => {
  if (neuerEditorialFadeInstances.has(root)) return;
  const video = root.querySelector('video');
  const copy = root.querySelector('.neuer-editorial-footer__content');
  if (!video || !copy) return;
  const mobile = matchMedia('(max-width: 749px)');
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  const controller = new AbortController();
  const options = { signal: controller.signal };
  let frame = 0;
  copy.style.transition = 'none';
  const update = () => {
    const prefix = mobile.matches ? 'fadeMobile' : 'fadeDesktop';
    const enabled = root.dataset[prefix + 'Enabled'] === 'true';
    const startPercent = Number(root.dataset[prefix + 'Start']);
    const duration = Math.max(0.1, Number(root.dataset[prefix + 'Duration']) / 1000 || 0.4);
    let opacity = 1;
    if (enabled && Number.isFinite(video.duration) && video.duration > 0) {
      const start = video.duration * Math.max(0, Math.min(95, startPercent || 0)) / 100;
      opacity = reducedMotion.matches
        ? (video.currentTime >= start ? 0 : 1)
        : Math.max(0, Math.min(1, 1 - (video.currentTime - start) / duration));
    }
    if (copy.contains(document.activeElement)) opacity = 1;
    copy.style.setProperty('--nd-video-copy-opacity', String(opacity));
    copy.style.opacity = String(opacity);
    copy.inert = opacity === 0;
  };
  const tick = () => {
    update();
    if (!video.paused && !video.ended && root.isConnected) frame = requestAnimationFrame(tick);
  };
  const play = () => { cancelAnimationFrame(frame); tick(); };
  const stop = () => { cancelAnimationFrame(frame); update(); };
  video.addEventListener('play', play, options);
  video.addEventListener('pause', stop, options);
  video.addEventListener('ended', stop, options);
  ['loadedmetadata', 'timeupdate', 'seeked', 'emptied'].forEach(event => video.addEventListener(event, update, options));
  mobile.addEventListener('change', update, options);
  reducedMotion.addEventListener('change', update, options);
  copy.addEventListener('focusin', update, options);
  copy.addEventListener('focusout', () => requestAnimationFrame(update), options);
  neuerEditorialFadeInstances.set(root, () => { controller.abort(); cancelAnimationFrame(frame); neuerEditorialFadeInstances.delete(root); });
  update();
  if (!video.paused) play();
};
document.querySelectorAll('[data-neuer-editorial-fade]').forEach(initNeuerEditorialFade);
document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-neuer-editorial-fade]').forEach(initNeuerEditorialFade));
document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-neuer-editorial-fade]').forEach(root => neuerEditorialFadeInstances.get(root)?.()));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["neuer-editable-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const slides = [...root.querySelectorAll('[data-slide]')];
      if (!slides.length) return;
      const counter = root.querySelector('[data-counter]');
      let active = 0;
      let timer;
      const mobile = window.matchMedia('(max-width:749px)');
      const updateVideos = () => slides.forEach((slide,i) => {
        const mobileVideo = slide.querySelector('.neuer-story-hero__video--mobile');
        const selected = mobile.matches && mobileVideo ? mobileVideo : slide.querySelector('.neuer-story-hero__video--desktop');
        slide.querySelectorAll('video').forEach(video => {
          if(i === active && video === selected && !document.hidden) video.play().catch(() => {});
          else video.pause();
        });
      });
      const show = (index) => {
        active = (index + slides.length) % slides.length;
        slides.forEach((slide, i) => {
          slide.hidden = i !== active;
          slide.classList.toggle('is-active', i === active);
        });
        updateVideos();
        if (counter) counter.textContent = `${active + 1} / ${slides.length}`;
      };
      const stop = () => window.clearInterval(timer);
      const start = () => {
        stop();
        if (root.dataset.autoplay === 'true' && slides.length > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          timer = window.setInterval(() => show(active + 1), Number(root.dataset.interval) || 6000);
        }
      };
      root.querySelector('[data-prev]')?.addEventListener('click', () => { show(active - 1); start(); });
      root.querySelector('[data-next]')?.addEventListener('click', () => { show(active + 1); start(); });
      let swipeStart;
      let swipeConsumed = false;
      root.addEventListener('pointerdown', event => {
        if (!mobile.matches || !event.isPrimary || event.target.closest('button')) return;
        swipeStart = { x:event.clientX, y:event.clientY, id:event.pointerId };
        swipeConsumed = false;
        stop();
      }, {passive:true});
      root.addEventListener('pointerup', event => {
        if (!swipeStart || swipeStart.id !== event.pointerId) return;
        const dx = event.clientX - swipeStart.x;
        const dy = event.clientY - swipeStart.y;
        if (mobile.matches && Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.3) {
          swipeConsumed = true;
          show(active + (dx < 0 ? 1 : -1));
        }
        swipeStart = null;
        start();
      }, {passive:true});
      root.addEventListener('pointercancel', () => {swipeStart = null;start();}, {passive:true});
      root.addEventListener('click', event => {
        if (!swipeConsumed) return;
        event.preventDefault();
        event.stopPropagation();
        swipeConsumed = false;
      }, true);
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', start);
      document.addEventListener('visibilitychange', () => { document.hidden ? stop() : start(); updateVideos(); });
      mobile.addEventListener('change',updateVideos);
      show(0);
      start();
    };
    document.querySelectorAll('[data-neuer-story-hero]').forEach(init);
    document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-neuer-story-hero]').forEach(init));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["neuer-editable-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (section) => {
      if (!section || section.dataset.observationsReady === 'true') return;
      section.dataset.observationsReady = 'true';
      const track = section.querySelector('[data-observations-track]');
      const previous = section.querySelector('[data-observations-prev]');
      const next = section.querySelector('[data-observations-next]');
      const dialog = section.querySelector('[data-observations-dialog]');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let visible = false;
      let pointerPaused = false;
      let autoplayTimer;
      const updateControls = () => {
        if (!track || !previous || !next) return;
        previous.disabled = track.scrollLeft < 4;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      };
      const advance = () => {
        if (!track) return;
        const end = track.scrollWidth - track.clientWidth;
        const behavior = reducedMotion.matches ? 'instant' : 'smooth';
        if (track.scrollLeft >= end - 4) {
          track.scrollTo({ left: 0, behavior });
          return;
        }
        const card = track.firstElementChild;
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        track.scrollBy({ left: (card?.getBoundingClientRect().width || track.clientWidth) + gap, behavior });
      };
      const syncAutoplay = () => {
        window.clearInterval(autoplayTimer);
        if (!track || section.dataset.observationsAutoplay !== 'true' || reducedMotion.matches) return;
        if (track.children.length < 2 || track.scrollWidth <= track.clientWidth + 4) return;
        if (!visible || pointerPaused || document.visibilityState !== 'visible' || section.contains(document.activeElement) || dialog?.open) return;
        const seconds = Math.min(10, Math.max(3, Number(section.dataset.observationsInterval) || 5));
        autoplayTimer = window.setInterval(advance, seconds * 1000);
      };
      if (track && previous && next) {
        previous.addEventListener('click', () => track.scrollBy({ left: -track.clientWidth * .85, behavior: 'smooth' }));
        next.addEventListener('click', () => track.scrollBy({ left: track.clientWidth * .85, behavior: 'smooth' }));
        track.addEventListener('scroll', updateControls, { passive: true });
        window.addEventListener('resize', updateControls);
        updateControls();
      }
      if (track && 'IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          visible = entries[0].isIntersecting;
          syncAutoplay();
        }, { threshold: .2 });
        observer.observe(section);
      } else {
        visible = true;
      }
      if (track) {
        section.addEventListener('mouseenter', () => {
          if (window.matchMedia('(hover: hover)').matches) {
            pointerPaused = true;
            syncAutoplay();
          }
        });
        section.addEventListener('mouseleave', () => {
          pointerPaused = false;
          syncAutoplay();
        });
        section.addEventListener('pointerdown', (event) => {
          if (event.pointerType !== 'touch') return;
          pointerPaused = true;
          syncAutoplay();
          window.setTimeout(() => {
            pointerPaused = false;
            syncAutoplay();
          }, 6000);
        });
        section.addEventListener('focusin', syncAutoplay);
        section.addEventListener('focusout', () => window.setTimeout(syncAutoplay, 0));
        document.addEventListener('visibilitychange', syncAutoplay);
        reducedMotion.addEventListener('change', syncAutoplay);
      }
      if (!dialog) return;
      section.querySelector('[data-observations-open]')?.addEventListener('click', () => dialog.showModal());
      dialog.querySelector('[data-observations-close]')?.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
      dialog.addEventListener('close', syncAutoplay);
      if (dialog.querySelector('[data-observations-feedback]')) dialog.showModal();
    };
    document.querySelectorAll('[data-neuer-observations]').forEach(init);
    document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-neuer-observations]').forEach(init));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["neuer-editorial-gallery"] && !Shopify.designMode) return;
  try {
    
const initNeuerEditorialGallery=root=>{
  if(root.dataset.ready)return;root.dataset.ready='true';

  if(root.classList.contains('neuer-gallery--reference')){
    const grid=root.querySelector('.neuer-gallery__grid');
    const figures=[...grid.querySelectorAll('figure')];
    let frame=0;
    const layout=()=>{
      const total=grid.getBoundingClientRect().width;
      if(!total)return;
      const columns=window.matchMedia('(max-width:749px)').matches?2:window.matchMedia('(max-width:989px)').matches?3:parseInt(getComputedStyle(root).getPropertyValue('--ng-columns'),10)||5;
      const gap=parseFloat(getComputedStyle(root).getPropertyValue('--ng-gap'))||0;
      const pattern=[1.12,.94,1.08,1.04,.98];
      const weights=Array.from({length:columns},(_,i)=>columns===2?1:pattern[i%pattern.length]);
      const sum=weights.reduce((a,b)=>a+b,0);
      const widths=weights.map(weight=>(total-gap*(columns-1))*weight/sum);
      const offsets=widths.map((_,i)=>widths.slice(0,i).reduce((a,b)=>a+b,0)+gap*i);
      const heights=Array(columns).fill(0);
      root.classList.add('neuer-gallery--reference-ready');
      figures.forEach(figure=>{
        const column=heights.indexOf(Math.min(...heights));
        figure.style.width=widths[column]+'px';
        figure.style.left=offsets[column]+'px';
        figure.style.top=heights[column]+'px';
        const height=figure.getBoundingClientRect().height;
        heights[column]+=height+gap;
      });
      grid.style.height=Math.max(0,...heights.map(height=>height-gap))+'px';
    };
    const schedule=()=>{cancelAnimationFrame(frame);frame=requestAnimationFrame(layout)};
    const observer=new ResizeObserver(schedule);
    figures.forEach(figure=>{
      observer.observe(figure.querySelector('a'));
      const caption=figure.querySelector('figcaption');
      if(caption)observer.observe(caption);
    });
    let previousWidth=0;
    const gridObserver=new ResizeObserver(entries=>{
      const width=entries[0].contentRect.width;
      if(Math.abs(width-previousWidth)>.1){previousWidth=width;schedule()}
    });
    gridObserver.observe(grid);
    layout();
    root.addEventListener('neuer:gallery:unload',()=>{observer.disconnect();gridObserver.disconnect();cancelAnimationFrame(frame)},{once:true});
  }else if(root.classList.contains('neuer-gallery--portrait')){
    const grid=root.querySelector('.neuer-gallery__grid');
    const figures=[...grid.querySelectorAll('figure')];
    let layoutFrame=0;
    const layout=()=>{
      const gap=parseFloat(getComputedStyle(grid).rowGap)||0;
      figures.forEach(figure=>{
        const photo=figure.querySelector('a');
        const caption=figure.querySelector('figcaption');
        const height=photo.getBoundingClientRect().height+(caption?caption.getBoundingClientRect().height:0);
        figure.style.gridRow='span '+Math.max(1,Math.ceil((height+gap)/(4+gap)));
      });
      root.classList.add('neuer-gallery--masonry');
    };
    const schedule=()=>{cancelAnimationFrame(layoutFrame);layoutFrame=requestAnimationFrame(layout)};
    const observer=new ResizeObserver(schedule);
    figures.forEach(figure=>{
      observer.observe(figure.querySelector('a'));
      const caption=figure.querySelector('figcaption');
      if(caption)observer.observe(caption);
    });
    layout();
    root.addEventListener('neuer:gallery:unload',()=>{observer.disconnect();cancelAnimationFrame(layoutFrame)},{once:true});
  }

  const dialog=root.querySelector('dialog');if(!dialog?.showModal)return;
  const links=[...root.querySelectorAll('[data-gallery-image]')],image=dialog.querySelector('img');let active=0,restoreOverflow='';
  const show=index=>{active=(index+links.length)%links.length;image.src=links[active].href;image.alt=links[active].querySelector('img').alt;};
  links.forEach((link,i)=>link.addEventListener('click',event=>{event.preventDefault();show(i);restoreOverflow=document.documentElement.style.overflow;document.documentElement.style.overflow='hidden';dialog.showModal();}));
  root.querySelector('[data-gallery-close]').addEventListener('click',()=>dialog.close());
  root.querySelector('[data-gallery-previous]').addEventListener('click',()=>show(active-1));
  root.querySelector('[data-gallery-next]').addEventListener('click',()=>show(active+1));
  dialog.addEventListener('keydown',event=>{if(event.key==='ArrowLeft'){event.preventDefault();show(active-1)}if(event.key==='ArrowRight'){event.preventDefault();show(active+1)}});
  dialog.addEventListener('close',()=>{document.documentElement.style.overflow=restoreOverflow;links[active]?.focus()});
};
document.querySelectorAll('[data-neuer-gallery]').forEach(initNeuerEditorialGallery);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-neuer-gallery]').forEach(initNeuerEditorialGallery));
document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('[data-neuer-gallery]').forEach(root=>root.dispatchEvent(new Event('neuer:gallery:unload'))));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["neuer-home"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-neuer-home]').forEach((root) => {
    const slides = Array.from(root.querySelectorAll('[data-slide]'));
    const dots = Array.from(root.querySelectorAll('[data-dot]'));
    const previous = root.querySelector('[data-prev]');
    const next = root.querySelector('[data-next]');
    const autoplay = root.dataset.autoplay === 'true';
    const interval = Number(root.dataset.interval) || 6000;
    let active = 0;
    let timer;

    const show = (nextIndex) => {
      active = (nextIndex + slides.length) % slides.length;
      slides.forEach((slide, index) => {
        const selected = index === active;
        slide.hidden = !selected;
        slide.classList.toggle('is-active', selected);
      });
      dots.forEach((dot, index) => {
        if (index === active) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    };

    const stop = () => window.clearInterval(timer);
    const start = () => {
      stop();
      if (autoplay && slides.length > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        timer = window.setInterval(() => show(active + 1), interval);
      }
    };

    previous?.addEventListener('click', () => { show(active - 1); start(); });
    next?.addEventListener('click', () => { show(active + 1); start(); });
    dots.forEach((dot) => dot.addEventListener('click', () => { show(Number(dot.dataset.dot)); start(); }));
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);
    start();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["neuer-listing-products"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["neuer-product-films"] && !Shopify.designMode) return;
  try {
    
const initNeuerFilms=root=>{
 if(root.dataset.ready)return;root.dataset.ready='true';
 const track=root.querySelector('[data-film-track]'),cards=[...track.querySelectorAll('.neuer-films__card')],pager=root.querySelector('[data-film-pagination]');
 const reduced=matchMedia('(prefers-reduced-motion: reduce)');let buttons=[];
 if(pager)buttons=cards.map((card,i)=>{const button=document.createElement('button');button.type='button';button.setAttribute('aria-label',String(i+1));button.setAttribute('aria-current',String(i===0));button.addEventListener('click',()=>{buttons.forEach((b,n)=>b.setAttribute('aria-current',String(n===i)));track.scrollTo({left:card.offsetLeft-cards[0].offsetLeft,behavior:'instant'});if(track.scrollWidth<=track.clientWidth+1)card.querySelector('[data-film-play]').focus({preventScroll:true})});pager.append(button);return button});
 let frame;track.addEventListener('scroll',()=>{cancelAnimationFrame(frame);frame=requestAnimationFrame(()=>{let nearest=0,distance=Infinity;cards.forEach((card,i)=>{const delta=Math.abs(card.offsetLeft-cards[0].offsetLeft-track.scrollLeft);if(delta<distance){distance=delta;nearest=i}});buttons.forEach((b,i)=>b.setAttribute('aria-current',String(i===nearest)))})},{passive:true});
 const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{const video=entry.target.querySelector('video');if(entry.isIntersecting&&!reduced.matches&&!video.dataset.userPaused){video.play().then(()=>entry.target.classList.remove('is-paused')).catch(()=>entry.target.classList.add('is-paused'))}else video.pause()}),{threshold:.35});
 cards.forEach(card=>{const video=card.querySelector('video'),button=card.querySelector('[data-film-play]');observer.observe(card);if(reduced.matches)card.classList.add('is-paused');video.addEventListener('play',()=>{button.setAttribute('aria-pressed','true')});video.addEventListener('pause',()=>{button.setAttribute('aria-pressed','false')});button.addEventListener('click',()=>{if(video.paused){delete video.dataset.userPaused;video.play().then(()=>card.classList.remove('is-paused')).catch(()=>{})}else{video.dataset.userPaused='true';video.pause();card.classList.add('is-paused')}})});
 document.addEventListener('visibilitychange',()=>{cards.forEach(card=>{const video=card.querySelector('video');if(document.hidden)video.pause();else if(!reduced.matches&&!video.dataset.userPaused&&card.getBoundingClientRect().top<innerHeight&&card.getBoundingClientRect().bottom>0)video.play().catch(()=>{})})});
 document.addEventListener('shopify:section:unload',event=>{if(event.target.contains(root)){observer.disconnect();cancelAnimationFrame(frame)}},{once:true});
};
document.querySelectorAll('[data-neuer-films]').forEach(initNeuerFilms);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-neuer-films]').forEach(initNeuerFilms));

  } catch(e) { console.error(e); }
})();
})();
